function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, undefined, groups); }; var _super = RegExp.prototype; var _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = new RegExp(re, flags); _groups.set(_this, groups || _groups.get(re)); return _setPrototypeOf(_this, BabelRegExp.prototype); } _inherits(BabelRegExp, RegExp); BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); if (result) result.groups = buildGroups(result, this); return result; }; BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if (typeof substitution === "string") { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { return "$" + groups[name]; })); } else if (typeof substitution === "function") { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = arguments; if (_typeof(args[args.length - 1]) !== "object") { args = [].slice.call(args); args.push(buildGroups(args, _this)); } return substitution.apply(this, args); }); } else { return _super[Symbol.replace].call(this, str, substitution); } }; function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { groups[name] = result[g[name]]; return groups; }, Object.create(null)); } return _wrapRegExp.apply(this, arguments); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useSWRInfinite } from 'swr';
import { fetchWithToken } from '@adsk/acs-sc-web-platform-api';
import { ALLOY_KEY_PREFIX, baseParser, setDataInStorage } from '../commonCache';

var alloyPrefix = function alloyPrefix(str) {
  return str ? "".concat(ALLOY_KEY_PREFIX).concat(str) : str;
};

var removeSWRPart = function removeSWRPart(key) {
  var _re$groups;

  var re = key.match( /*#__PURE__*/_wrapRegExp(/arg@"inf"@"(.+)"/, {
    url: 1
  }));
  return re === null || re === void 0 ? void 0 : (_re$groups = re.groups) === null || _re$groups === void 0 ? void 0 : _re$groups.url;
};

var defaultGetNextKey = function defaultGetNextKey(data) {
  return (data === null || data === void 0 ? void 0 : data.pagination.nextUrl) || '';
};

var loadDataFromSessionStorage = function loadDataFromSessionStorage(url, getNextKey) {
  var res = [];
  var currentUrl = url;

  while (currentUrl) {
    var _data = baseParser(sessionStorage.getItem(alloyPrefix(currentUrl)));

    if (_data) {
      res.push(_data);
    }

    currentUrl = _data && getNextKey(_data);
  }

  return res.length === 0 ? undefined : res;
};

var saveInStorage = function saveInStorage(data, key, getNextKey) {
  var storeKey = data.length - 1 === 0 ? removeSWRPart(key) : getNextKey(data[data.length - 2]);
  setDataInStorage(data[data.length - 1], storeKey);
};

var clearAllDataFromSessionStorage = function clearAllDataFromSessionStorage(url, getNextKey) {
  var keysToRemove = [];
  var curKey = url;

  while (curKey !== '') {
    if (curKey) {
      keysToRemove.push(alloyPrefix(curKey));
    }

    curKey = getNextKey(JSON.parse(sessionStorage.getItem(alloyPrefix(curKey))));
  }

  keysToRemove.forEach(function (key) {
    return sessionStorage.removeItem(key);
  });
};

export var useGetAllPaginatedData = function useGetAllPaginatedData(_ref) {
  var url = _ref.url,
      _ref$fetcher = _ref.fetcher,
      fetcher = _ref$fetcher === void 0 ? fetchWithToken : _ref$fetcher,
      _ref$getNextKey = _ref.getNextKey,
      getNextKey = _ref$getNextKey === void 0 ? defaultGetNextKey : _ref$getNextKey;
  var initialLoading = useRef(!!url);
  var initialData = useMemo(function () {
    return loadDataFromSessionStorage(url, getNextKey);
  }, [url, getNextKey]);

  var _useSWRInfinite = useSWRInfinite(function (pageIndex, previousPageData) {
    return pageIndex === 0 ? url : getNextKey(previousPageData);
  }, fetcher, {
    initialData: initialData,
    onSuccess: function onSuccess(newData, key) {
      return saveInStorage(newData, key, getNextKey);
    },
    revalidateOnMount: true,
    revalidateOnFocus: false,
    shouldRetryOnError: false
  }),
      data = _useSWRInfinite.data,
      error = _useSWRInfinite.error,
      revalidate = _useSWRInfinite.revalidate,
      setSize = _useSWRInfinite.setSize;

  useEffect(function () {
    if (data && !!getNextKey(data[data.length - 1])) {
      setSize(data.length + 1);
    }
  }, [data, getNextKey, setSize]);
  var hasMoreData = useMemo(function () {
    return !!url && !(data && data.length && !getNextKey(data[data.length - 1]));
  }, [url, data, getNextKey]);
  useEffect(function () {
    initialLoading.current = false;
  }, [hasMoreData]);
  var clearSessionStorage = useCallback(function () {
    clearAllDataFromSessionStorage(url, getNextKey);
  }, [getNextKey, url]);
  var loading = initialLoading.current || !error && hasMoreData;
  return {
    loading: loading,
    retry: revalidate,
    clearSessionStorage: clearSessionStorage,
    data: data === undefined ? [] : data,
    error: error
  };
};
//# sourceMappingURL=useGetAllPaginatedData.js.map